import { Queue } from '@tf/queue';
var ControlImpl = /** @class */ (function () {
    function ControlImpl(key) {
        this.key = key;
        this._dirty = false;
        this._errors = null;
        this._validationState = 'valid';
        this._touched = false;
        this._valid = true;
        this._value = null;
        this._stateQueue = new Queue();
        this._valueQueue = new Queue();
        this._validationStateQueue = new Queue();
    }
    Object.defineProperty(ControlImpl.prototype, "dirty", {
        get: function () {
            return this._dirty;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ControlImpl.prototype, "errors", {
        get: function () {
            return this._errors;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ControlImpl.prototype, "invalid", {
        get: function () {
            return this._valid === false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ControlImpl.prototype, "pristine", {
        get: function () {
            return this._dirty === false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ControlImpl.prototype, "validationState", {
        get: function () {
            return this._validationState;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ControlImpl.prototype, "touched", {
        get: function () {
            return this._touched;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ControlImpl.prototype, "valid", {
        get: function () {
            return this._valid;
        },
        enumerable: false,
        configurable: true
    });
    ControlImpl.prototype.markDirty = function (emit) {
        this._dirty = true;
        this.emitState(emit);
        return this;
    };
    ControlImpl.prototype.markPristine = function (emit) {
        this._dirty = false;
        this.emitState(emit);
        return this;
    };
    ControlImpl.prototype.markTouched = function (emit) {
        this._touched = true;
        this.emitState(emit);
        return this;
    };
    ControlImpl.prototype.markUntouched = function (emit) {
        this._touched = false;
        this.emitState(emit);
        return this;
    };
    ControlImpl.prototype.onChange = function (callback) {
        this._valueQueue.push(callback);
    };
    ControlImpl.prototype.onStateChange = function (callback) {
        this._stateQueue.push(callback);
    };
    ControlImpl.prototype.onValidationStateChange = function (callback) {
        this._validationStateQueue.push(callback);
    };
    ControlImpl.prototype.reset = function (value, emit) {
        if (value === void 0) { value = null; }
        this.setValue(value, emit);
        this.markPristine();
        this.markUntouched();
        this.emitState(emit);
        return this;
    };
    ControlImpl.prototype.emitState = function (emit) {
        if (emit !== false) {
            this._stateQueue.call({
                dirty: this.dirty,
                touched: this.touched,
                valid: this.valid,
            });
        }
    };
    ControlImpl.prototype.emitValidationState = function (emit) {
        if (emit !== false) {
            this._validationStateQueue.call(this.validationState);
        }
    };
    ControlImpl.prototype.emitValue = function (emit) {
        if (emit !== false) {
            this._valueQueue.call(this.value);
        }
    };
    return ControlImpl;
}());
export { ControlImpl };
//# sourceMappingURL=data:application/json;base64,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